import compose from 'utils/compose';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import { withTheme } from '@emotion/react';

import { rootUiActions } from 'companion-app-components/flux/root-ui';
import { getCategoryBudgetTransactions } from 'companion-app-components/flux/budgets/budgetsSelectors';

import IndividualCategoryView from './individualCategoryView';
import styles from './styles';

const mapStateToProps = (state, props) => ({
  data: getCategoryBudgetTransactions(state, props.budgetId, props.categoryId, false, null, null, props.allCategoryIdsOfBudget, props.isEverythingElse, props.displayLabel),
  clickedMonthDate: props?.clickedMonthDate,
});

const mapDispatchToProps = (dispatch) => ({
  removeDialog: () => dispatch(rootUiActions.removeDialog()),
});

export default compose(
  withTheme,
  connect(mapStateToProps, mapDispatchToProps),
)(withStyles(IndividualCategoryView, styles));
